import React, { useState, useEffect, useContext } from "react";
import {
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  Input,
  InputGroup,
} from "reactstrap";
import { useController, useForm } from "react-hook-form";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { Button } from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { showAlert } from "../../../Services/Shared.service";
import Checkbox from "@mui/material/Checkbox";
import CustomizerContext from "../../../_helper/Customizer";
import { ArrowDown, ArrowUp, Watch } from "react-feather";
import {
  getSchemeDeductionsAll,
  createSchemeDeduction,

  updateSchemeDeduction} from "../../../Services/Driver.service";
import SharedDataContext from "../../../_helper/SharedData";
import { getCorporateClientsListBySearch } from "../../../Services/CorporateClient.service";
import { getPackagesListBySearch } from "../../../Services/Packages.service";

export const DriverSchemeDeductionForm = ({
  driverScheme,
  driverDeduction,
  isSearch,
  setIsSearch,
  handleBack,
  setSelectedServiceCityId
}) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {},
  });

  const { cityData,setTabValue,globalCityField } = useContext(SharedDataContext);
  const [editId, setEditId] = useState(null);

  const { mix_background_layout } = useContext(CustomizerContext);
  const [isAdvanced, setIsAdvanced] = useState(false);
  const [selectedScheme,setSelectedScheme] = useState({});
  const [schemeDeductionList,setSchemeDeductionsList] = useState([]);
  const { ServiceCity, Packages,ValueType,CorprateClient, BookingType,DeductionValue ,IsDisplay} = watch();
  const hasSchemeServiceCity = driverScheme?.serviceCityId != null;
  const schemeServiceCityOption = hasSchemeServiceCity
    ? cityData.find((element) => element.id === driverScheme.serviceCityId)
    : null;

  useEffect(()=>{
    fetchSchemDeductionOpt(driverScheme.id,driverDeduction.id,driverScheme.serviceCityId)    
  },[])

  const fetchSchemDeductionOpt =(driverSchemeId,deductionTypeId,serviceCityId,)=>{

    let obj ={
      serviceCityId:serviceCityId,
      driverTypeId:driverSchemeId,
      deductionTypeId:deductionTypeId
    }

    getSchemeDeductionsAll(obj).then((resp)=>{
      if(resp.status === 200){
        const data = []
      resp.data.searchResponse.forEach((element)=>{
        data.push({
          label:"Value : "+element.value,
          value:element,
          id:element.id
        })
      })
      setSchemeDeductionsList(data);
    }
    })

  }

  const ValueTypeArr = [
    { label: "Percentage", value: "P" },
    { label: "Amount", value: "A" },
  ];

  const bookingTypes = [
    { label: "MobileApp", value: "MobileApp" },
    { label: "DriverApp", value: "DriverApp" },
    { label: "Website", value: "Website" },
    { label: "PartnerApi", value: "PartnerApi" },
    { label: "CustomerService", value: "CustomerService" },
    { label: "IRCTC", value: "IRCTC" },
    { label: "BookingWeb", value: "BookingWeb" },
    { label: "JustDial", value: "JustDial" },
    { label: "Integrator", value: "Integrator" },
    { label: "AirportBooking", value: "AirportBooking" },
    { label: "City", value: "City" },
    { label: "CRON", value: "CRON" },
    { label: "All", value: "All" },
    { label: "Others", value: "Others" },
    { label: "CallCenter", value: "CallCenter" },
  ];

  const handleNewClick = () => {
    console.log("Driver deduction",driverDeduction)
    reset({
      DriverType: driverScheme ? driverScheme.name : "",
      DeductionType: driverDeduction ? driverDeduction.deductionType : "",
      ServiceCity: schemeServiceCityOption ?? null,
    });
    setIsSearch(false);
  };

  const handleDeductionSubmit = (formValues) => {
    const body = {
      driverSchemeId: driverScheme?driverScheme.id:null,
      driverDeductionId: driverDeduction?driverDeduction.id:null,
      valueType: formValues ? formValues.ValueType.value : "",
      value: formValues ? formValues.DeductionValue : "",
      serviceCityId: formValues.ServiceCity?.id ?? null,
      bookingDeduction:formValues?formValues.BookingType.value:"",
      // corporateClientId:formValues?formValues.CorprateClient.value.id:null,
      // packagesId:formValues?formValues.Packages.value.id:null,
      createdOn:selectedScheme.createdOn,
      createdById:selectedScheme.createdById,
      deletedOn:selectedScheme.deletedOn,
      deletedById:selectedScheme.deletedById
  };

    if (editId !== null) {
      body["id"] = editId;
      updateSchemeDeduction(body).then((resp)=>{
        setSelectedServiceCityId(body.serviceCityId);
        showAlert("success","Updated Successfully")
        setIsSearch(true)
        setTabValue(prev=>prev+1)
      }).catch((err) => {
        showAlert("error", "Something went wrong");
      });
    } else {
      createSchemeDeduction(body)
        .then((resp) => {
          setSelectedServiceCityId(body.serviceCityId);
          showAlert("success", "Scheme Deduction successfully created");
          setIsSearch(true)
          setTabValue(prev=>prev+1)
        })
        .catch((err) => {
          showAlert("error", "Something went wrong");
        });
    }
  };

  const handleExistClick=(schemeDeduction)=>{
    // console.log("schemeDeduction",schemeDeduction.value);
    // handleExistClick
    setIsSearch(false)
    setSelectedScheme(schemeDeduction.value)
    setEditId(schemeDeduction.value.id)
    reset({
      // ServiceCity:cityData.find((item)=>item.id===selectedScheme.serviceCityId?selectedScheme.serviceCityId:driverScheme.serviceCityId),
      ServiceCity: schemeServiceCityOption ?? null,
      DeductionValue:schemeDeduction.value,
      ValueType:ValueTypeArr.find((item)=>item.value === schemeDeduction.valueType),
      // DriverType:driverScheme?driverScheme.name:"",
      BookingType:bookingTypes.find((item)=>item.value === schemeDeduction.bookingTypeDeduction),
      IsDisplay:schemeDeduction.isDeleted?true:false
    })
  }


  useEffect(()=>{
    reset({
      // ServiceCity:cityData.find((item)=>item.id===selectedScheme.serviceCityId?selectedScheme.serviceCityId:driverScheme.serviceCityId),
      ServiceCity: schemeServiceCityOption ?? null,
      DeductionValue:selectedScheme.value,
      ValueType:ValueTypeArr.find((item)=>item.value === selectedScheme.valueType),
      // DriverType:driverScheme?driverScheme.name:"",
      BookingType:bookingTypes.find((item)=>item.value === selectedScheme.bookingTypeDeduction),
      IsDisplay:selectedScheme.isDeleted?true:false
    })
  },[selectedScheme])
  
  const getPackageOptions = async (inputValue) => {
    if (inputValue.length) {
      console.log(inputValue);
      let obj = {
        serviceCityId:driverScheme.serviceCityId,
        name: inputValue,
      };
      return getPackagesListBySearch(obj).then((result) => {
        const mappedArray = result.data.list.map((item) => ({
          value: item,
          label: item.name,
        }));

        return mappedArray;
      });
    }
  };


  const getCorporateClientOpt = async (inputValue) => {
    if (inputValue.length) {
      console.log(inputValue);
      let obj = {
        serviceCityId:driverScheme.serviceCityId,
        name: inputValue
      };
      return getCorporateClientsListBySearch(obj).then((result) => {
        const mappedArray = result.data.list.map((item) => ({
          value: item,
          label: item.companyName,
        }));
       
        return mappedArray;
      });
    }
  };
  return (
    <div>
      {isSearch ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection:"column",
            gap:"1rem"
          }}
        >
          <div
            style={{
              width: "400px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Button
              sx={{
                width: "100%",
                fontSize: "1rem",
                color: "#41CC7D",
                borderColor: "#41CC7D",
                "&:hover": {
                  borderColor: "#41CC7D",
                },
              }}
              variant="outlined"
              startIcon={<AddBoxIcon sx={{ color: "#41CC7D" }} />}
              onClick={() => {
                handleNewClick();
              }}
            >
              New Deduction Value
            </Button>

            <Select
              cacheOptions
              placeholder={"Search Deduction Value"}
              options={schemeDeductionList}
              // loadOptions={getSchemeDeductionOpt}
              onChange={handleExistClick}
            />
          </div>
          <button type="button"  className="btn submit-button" onClick={()=>handleBack()}>Back</button>

        </div>
      ) : (
        <div>
          <Form onSubmit={handleSubmit(handleDeductionSubmit)}>
            <Row>
              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">DriverScheme</Label>
                <Col lg="12">
                  <input
                  disabled={driverScheme?true:false}
                  value={driverScheme?driverScheme.name:""}
                    className="form-control"
                    type="text"
                    {...register("DriverType", {
                      onChange: (e) => {
                        setValue("DriverType", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.DriverType?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">
                  Deduction Type
                </Label>
                <Col lg="12">
                  <input
                  value={driverDeduction?driverDeduction.deductionDisplayName:""}
                  disabled={driverScheme?true:false}
                    className="form-control"
                    type="text"
                    {...register("DeductionType", {
                     
                      onChange: (e) => {
                        setValue("DeductionType", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.DeductionType?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">Value Type</Label>
                <Col lg="12">
                  <Select

                  value={ValueType}
                    options={ValueTypeArr}
                    {...register("ValueType", {
                      required: {
                        value: true,
                        message: "ValueType is required",
                      },
                    })}
                    onChange={(e) => setValue("ValueType",e)}
                    placeholder={"Select Value Type"}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.ValueType?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">
                  Deduction Value
                </Label>
                <Col lg="12">
                  <input
                  value={DeductionValue}
                    className="form-control"
                    type="text"
                    {...register("DeductionValue", {
                      required: {
                        value: true,
                        message: "DeductionValue is required",
                      },
                      onChange: (e) => {
                        setValue("DeductionValue", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.DeductionValue?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">Service City</Label>
                <Col lg="12">
                  <Select
                    value={ServiceCity}
                    options={cityData}
                    {...register("ServiceCity", {
                      required: {
                        value: true,
                        message: "ServiceCity is required",
                      },
                    })}
                    placeholder={"Select Service City"}
                    onChange={(e) => setValue("ServiceCity", e)}
                    isDisabled={hasSchemeServiceCity}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.ServiceCity?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">Booking Type</Label>
                <Col lg="12">
                  <Select
                    value={BookingType}
                    options={bookingTypes}
                    {...register("BookingType", {
                      required: {
                        value: true,
                        message: "BookingType is required",
                      },
                    })}
                    placeholder={"Select BookingType"}
                    onChange={(e) => setValue("BookingType", e)}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.BookingType?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup
                className="col-lg-4"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  className={
                    mix_background_layout == "dark-only"
                      ? "checkbox-dark p-0"
                      : "checkbox p-0"
                  }
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                  checked={IsDisplay}
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                    }}
                    id="IsDisplay"
                    type="checkbox"
                    {...register("IsDisplay", {})}
                  />

                  <Label className="mb-0" for="IsDisplay">
                    {"IsDisplay"}
                  </Label>
                </div>
              </FormGroup>
            </Row>
            <Row>
              <div
                style={{
                  color: "#11BF5C",
                  textDecoration: "underline",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => setIsAdvanced(!isAdvanced)}
              >
                Advanced Configurations{" "}
                {isAdvanced ? (
                  <ArrowUp
                    style={{ width: "15px", height: "15px", marginLeft: "5px" }}
                  />
                ) : (
                  <ArrowDown
                    style={{ width: "15px", height: "15px", marginLeft: "5px" }}
                  />
                )}
              </div>
            </Row>
            {isAdvanced ? (
              <Row>
                <FormGroup className="col-lg-4">
                  <Label className="col-lg-12 col-form-label">
                    Corporate Clients
                  </Label>
                  <Col className="col-lg-12">
                    <AsyncSelect
                    loadOptions={getCorporateClientOpt}
                      value={
                        CorprateClient
                          ? CorprateClient
                          : { label: "Search Corporate Client", value: "" }
                      }
                      {...register("CorprateClient", {})}
                      onChange={(e) => setValue("CorprateClient", e)}
                      placeholder={"Search Corporate Clients"}
                    />
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-4">
                  <Label className="col-lg-12 col-form-label">Packages</Label>
                  <Col className="col-lg-12">
                    <AsyncSelect
                    loadOptions={getPackageOptions}
                      value={
                        Packages
                          ? Packages
                          : { label: "Search Packages", value: "" }
                      }
                      {...register("Packages", {})}
                      onChange={(e) => setValue("Packages", e)}
                      placeholder={"Search Packages"}
                    />
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-4">
                  <Label className="col-lg-12 col-form-label">
                    Minimum Distance
                  </Label>
                  <Col className="col-lg-12">
                    <input
                      className="form-control"
                      type="number"
                      {...register("minDistance", {
                        onChange: (e) => {
                          setValue("minDistance", e.target.value.trimStart());
                        },
                      })}
                    />
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-4">
                  <Label className="col-lg-12 col-form-label">
                    Maximum Distance
                  </Label>
                  <Col className="col-lg-12">
                    <input
                      className="form-control"
                      type="number"
                      {...register("maxDistance", {
                        onChange: (e) => {
                          setValue("maxDistance", e.target.value.trimStart());
                        },
                      })}
                    />
                  </Col>
                </FormGroup>
              </Row>
            ) : null}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "3rem",
                gap:"1rem"
              }}
            >
              <button type="button"  className="btn submit-button" onClick={()=>setIsSearch(true)}>Back</button>
              <button type="submit" className="btn submit-button">
                {"Next"}
              </button>
            </div>
          </Form>
        </div>
      )}
    </div>
  );
};
